import React, { FC, ReactNode } from "react";

import Switch, { SwitchProps } from "antd/es/switch";
import cn from "classnames";

import styles from "./LabeledSwitch.module.scss";
import Option from "./Option";

type LabelPosition = "left" | "right";

interface Props extends SwitchProps {
  description?: ReactNode;
  labelClassName?: string;
  labelPosition?: LabelPosition;
}

const LabeledSwitch: FC<Props> = ({
  checked,
  description,
  disabled,
  labelClassName,
  labelPosition = "left",
  title,
  ...props
}) => {
  return (
    <label className={cn(styles.container, labelClassName, { [styles.disabled]: disabled })}>
      {labelPosition === "left" ? (
        <Option description={description} disabled={!checked} title={title} />
      ) : undefined}
      <Switch checked={checked} disabled={disabled} {...props} />
      {labelPosition === "right" ? (
        <Option description={description} disabled={!checked} title={title} />
      ) : undefined}
    </label>
  );
};

export default LabeledSwitch;
